import React from 'react'

// prettier-ignore
export const PersonAddress = {
  Create: React.lazy(() => import('./create')),
  Edit:   React.lazy(() => import('./edit')),
}
